import { FC } from 'react';

import { TabPanelProps } from './TabPanel.types';
import { useTabContext } from '@components/hooks';
import { TabPanelStyled } from './TabPanel.styles';
import { getPanelId, getTabId } from '@components/helpers/tab';

const TabPanel: FC<TabPanelProps> = ({ children, value }) => {
  const context = useTabContext();
  if (context === undefined) {
    throw new Error('No TabContext provided.');
  }

  const isActiveTab = value === context?.activeTab;

  if (!isActiveTab) {
    return null;
  }

  const id = getPanelId(context.idPrefix, value);
  const tabId = getTabId(context.idPrefix, value);

  return (
    <TabPanelStyled id={id} role="tabpanel" aria-labelledby={tabId}>
      {children}
    </TabPanelStyled>
  );
};

export default TabPanel;
